import ContainerModules from './ContainerModule';
import OffersHeader from './OfferHeader';

const OffersWidget = ({ directNumber, ticketId }) => {
  return (
    <>
      <OffersHeader />
      <ContainerModules directNumber={directNumber} ticketId={ticketId} />
    </>
  );
};

export default OffersWidget;
